import { React, forwardRef, useState, useRef, useImperativeHandle } from 'react';
import styled from 'styled-components';

import SelectOnPath from '../../image/SelectOn.png';
import SelectOffPath from '../../image/SelectOff.png';

const CenterTypeSelect = forwardRef((props, ref) => {
  const { setVal } = props;
	// const [firstOption, setFirstOption] = useState();
	const [isClicked, setIsClicked] = useState(false);
	const [defaultVal, setDefaultVal] = useState({ value: 'PT', text: '1 : 1 PT' });

	const SelectRef = useRef()

	const options = [
		{ value: 'PT', text: '1 : 1 PT' },
		{ value: 'groupTraining', text: '그룹 트레이닝' },
		{ value: 'boutiqueFitness', text: '부티크 피트니스' },
		{ value: 'normalFitness', text: '일반 피트니스 센터' },
		{ value: 'pilates', text: '필라테스' },
		{ value: 'yoga', text: 'yoga' },
		{ value: 'crossfit', text: '크로스핏' },
		{ value: 'basketball', text: '농구' },
		{ value: 'tennis', text: '테니스' },
		{ value: 'baseball', text: '야구' },
		{ value: 'soccer', text: '축구' },
		{ value: 'spinning', text: '스피닝' },
		{ value: 'ballet', text: '발레' },
		{ value: 'boxing', text: '복싱' },
		{ value: 'dance', text: '댄스' },
		{ value: 'golf', text: '골프' },
		{ value: 'other', text: '기타' },
	];

	useImperativeHandle(ref, () => ({
		getValue: (val) => {
			return defaultVal.text;
		}
	}))

	function onClick() {
		if (isClicked) {
			SelectRef.current.style.border = '1px solid #CBCBCB';
			SelectRef.current.style.height = `30px`;
			// SelectRef.current.style.height = firstOption;
			SelectRef.current.style.overflow = 'hidden';
			setIsClicked(false);
		}
		else {
			// setFirstOption(SelectRef.current.style.height);
			SelectRef.current.style.border = '1px solid #FF8B48';
			SelectRef.current.style.height = `240px`;
			SelectRef.current.style.overflowY = 'scroll';
			SelectRef.current.style.overflowX = 'none';
			setIsClicked(true);
		}
	}

	function optionalClick(index) {
		setDefaultVal(options[index]);
    setVal(options[index].text);
	}

	return (
		<TopLevelWrapper>
			<SelectBox
				ref={SelectRef}
				isClicked={isClicked}
				buttonPath={isClicked ? SelectOnPath : SelectOffPath}
				onClick={onClick}>
				{
					isClicked ?
						options.map((data, index) =>
							<OptionWrapper key={index} onClick={() => optionalClick(index)}>
								<Option>{data.text}</Option>
							</OptionWrapper>
						)
						:
						<OptionWrapper>
							<Option>
								{
									defaultVal.text
								}
							</Option>
						</OptionWrapper>
				}
			</SelectBox>
		</TopLevelWrapper>
	)
})

export default CenterTypeSelect;

const TopLevelWrapper = styled.div`
	display: flex;
	flex-direction: column;
	
	width: 238px;
	height: 30px;

	margin-top: 24px;
`;

const SelectBox = styled.div`
	position: absolute;
	display: flex;
	flex-direction: column;

	align-items: flex-start;

	width: 238px;
	height: 30px;

	border: 1px solid #CBCBCB;
	border-radius: 8px;
	overflow: hidden;

  background: url(${props => props.buttonPath}) no-repeat 96% ${props => props.isClicked ? `3` : `55`}%;
	background-color: rgba(255, 255, 255, 1);
  transition: all 0.3s ease-in-out;

	&:hover {
		cursor: pointer;
	}

	&::-webkit-scrollbar {
		width: 9px;
	}

	&::-webkit-scrollbar-thumb {
    box-shadow: inset 0 0 10px 20px #FF8B48;
		border: 3px solid transparent;
		height: 25px;
		// background-color: #FF8B48;
		border-radius: 200px;
	}

	&::-webkit-scrollbar-track {
    box-shadow: inset 0 0 10px 10px transparent;
		border: 4px solid transparent;
		background-color: transparent;
	}

	&::-webkit-scrollbar-track-piece {
		background-color: transparent;
	}
`;

const OptionWrapper = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;

	&:hover {
		cursor: pointer;
	}
`;

const Option = styled.p`
	font-family: NotoSansKR-Regular;
	font-size: 14px;
  
	margin: 6px 0 6px 8px;
`;